/**
 * Feature flags for catalog sections that are built but not yet live.
 *
 * The Add-on Subscriptions and One-Time Services sections were previously disabled with
 * `{false && ...}` in JSX, which left the code unreachable but still shipped, unlinted, and
 * un-runnable in any environment. Real flags let them be enabled per environment (a Pages
 * preview first) without a code change.
 */

/**
 * Read a boolean env flag without assuming `process` exists.
 *
 * The Workers runtime has no ambient `process`, so a bare `process.env.X` would throw a
 * ReferenceError there. CRA's webpack DefinePlugin statically replaces
 * `process.env.REACT_APP_*` at BUILD time, so this still works client-side -- but note the
 * consequence: client flags are baked into the bundle at build time and cannot be changed
 * by a runtime binding. Server-side, pass overrides explicitly via resolveCart's opts.
 */
function readFlag(name, fallback) {
  const env = (typeof process !== 'undefined' && process.env) || {};
  const raw = env[name];
  if (raw === undefined) return fallback;
  return raw === 'true' || raw === '1';
}

export const FEATURES = {
  addonSubscriptions: readFlag('REACT_APP_FEATURE_ADDONS', false),
  oneTimeServices: readFlag('REACT_APP_FEATURE_ONETIME', false),
};

/**
 * Merge caller overrides over the defaults.
 * The Cloudflare function must pass its own values because Workers `env` bindings are not
 * ambient: resolveCart(selection, { features: { addonSubscriptions: env.X === 'true' } }).
 */
export function resolveFeatures(overrides) {
  if (!overrides) return FEATURES;
  return { ...FEATURES, ...overrides };
}
